<template>
    <v-container>
        <calendar-mobile v-if="isMobile" />
        <calendar-desktop v-else />
    </v-container>
</template>

<script>

import CalendarMobile from "@/components/coach/routines/CalendarMobile";
import CalendarDesktop from "@/components/coach/routines/CalendarDesktop";

export default {
    components: {
        CalendarDesktop,
        CalendarMobile,
    },
}
</script>

<style scoped>

</style>
